module.exports = __webpack_public_path__ + "static/img/scalable-hris.9a45be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/scalable-hris.png
// module id = OHs5
// module chunks = 0